import { Box, Flex } from "@eworkit/iris";
import { CalendarBlankIcon, CloseCircleFillIcon } from "@eworkit/iris";
import React, { useCallback } from "react";

import { Button } from "@/components/Button";
import { Card } from "@/components/Card";
import { DateRange } from "@/components/dates";
import { Dropdown } from "@/eworkitComponents";
import { RangeComponent } from "@/views/Assignments/ListPage/filters/DateRange";

import "./date_range_picker_dropdown.scss";

interface ComponentProps extends Omit<React.HTMLAttributes<HTMLElement>, "value" | "onChange"> {
  range?: string;
  clearable?: boolean;
  label: string;
  onChange?: (value: any, cb?: () => void) => void;
}

const DateRangePickerDropdownComponent: React.FC<ComponentProps> = ({
  range,
  clearable = true,
  onChange,
  label,
  ...props
}) => {
  const emptyRange = !range;

  const [start, end] = range?.split(",") ?? [];

  const renderedLabel = emptyRange ? label : <DateRange from={start} to={end} />;

  const showClearIcon = clearable && !emptyRange;

  const onClear = () => onChange && onChange("");

  // to stop dropdown from closing after clicking on calendars
  const preventDropdownClose = useCallback((e: React.MouseEvent) => e.stopPropagation(), []);

  return (
    <Flex {...props}>
      <Dropdown
        target={
          <Button variant={"secondary"} size={"sm"}>
            <Flex alignItems={"center"}>
              <Box mr={"xs"}>{renderedLabel}</Box>
              {showClearIcon ? <CloseCircleFillIcon onClick={onClear} /> : <CalendarBlankIcon />}
            </Flex>
          </Button>
        }
        modifiers={{
          offset: {
            offset: "0, 12", // x-axis, y-axis (in pixels)
          },
        }}
        placement={"bottom-start"}
        content={
          <Card>
            <RangeComponent range={range} onChange={onChange} onClick={preventDropdownClose} />
          </Card>
        }
      />
    </Flex>
  );
};

export const DateRangeDropdownPicker = React.memo<ComponentProps>(({ range, onChange, ...props }) => {
  return <DateRangePickerDropdownComponent range={range} onChange={onChange} {...props} />;
});
